<script setup>
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {usePyCrawlFormatters} from "@/composables/admin/usePyCrawlAnalytics";

defineProps({
    jobs: {type: Array, required: true},
});

const {formatCount, formatDuration, formatDateTime} = usePyCrawlFormatters();
</script>

<template>
  <BaseCard>
    <h2 class="tw-text-xl tw-font-semibold tw-text-font-primary tw-mb-4">
      Recently Finished Jobs
    </h2>
    <DataTable>
      <TableHeaderRow class="!tw-grid-cols-12">
        <TableHeaderCell :col-span="1">
          Status
        </TableHeaderCell>
        <TableHeaderCell :col-span="3">
          Domain
        </TableHeaderCell>
        <TableHeaderCell :col-span="1">
          Duration
        </TableHeaderCell>
        <TableHeaderCell :col-span="1">
          Pages
        </TableHeaderCell>
        <TableHeaderCell :col-span="4">
          Finished At
        </TableHeaderCell>
        <TableHeaderCell :col-span="2">
          Links
        </TableHeaderCell>
      </TableHeaderRow>
      <TableBody v-if="jobs.length > 0">
        <TableRow
          v-for="(job, index) in jobs"
          :key="index"
        >
          <TableCell :col-span="1">
            <span
              :class="job.status === 'completed' ? 'tw-text-green-600' : 'tw-text-red-500'"
              class="tw-font-medium tw-capitalize"
            >{{ job.status }}</span>
          </TableCell>
          <TableCell :col-span="3">
            {{ job.domain ?? '—' }}
          </TableCell>
          <TableCell :col-span="1">
            {{ formatDuration(job.duration_seconds) }}
          </TableCell>
          <TableCell :col-span="1">
            {{ job.pages_crawled !== null ? formatCount(job.pages_crawled) : '—' }}
          </TableCell>
          <TableCell :col-span="4">
            {{ formatDateTime(job.finish_time) }}
          </TableCell>
          <TableCell :col-span="2">
            <div class="tw-flex tw-gap-2">
              <DefaultButton
                as="a"
                :href="job.cloudwatch_url"
                target="_blank"
                variant="primary-inverted"
                size="small"
                class="!tw-px-2"
                title="Logs"
              >
                <svg-vue
                  icon="icons/bullet-list"
                  class="tw-h-4 tw-w-4"
                />
              </DefaultButton>
              <DefaultButton
                v-if="job.storage_url"
                as="a"
                :href="job.storage_url"
                target="_blank"
                variant="primary-inverted"
                size="small"
                class="!tw-px-2"
                title="S3"
              >
                <svg-vue
                  icon="icons/download"
                  class="tw-h-4 tw-w-4"
                />
              </DefaultButton>
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
      <ZeroContent v-else>
        No recently finished jobs.
      </ZeroContent>
    </DataTable>
  </BaseCard>
</template>
